// extracted by mini-css-extract-plugin
export default {"buttonContainer":"buttonSpace_buttonContainer__uGFpI"};